export default __webpack_public_path__ + "static/media/projects.3cfd1c4b.mp4";